import * as React from "react";
import AppointmentPickDifferentTimeSlotContent from "./AppointmentPickDifferentTimeSlotContent.js";
/* empty css                                      */
const AppointmentPickDifferentTimeSlot = ({
  labels,
  loading,
  onClickPrevious,
  onSelectTimeSlot,
  selected,
  timeSlots
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: "appointment-pick-different-time-slot" }, /* @__PURE__ */ React.createElement(
    AppointmentPickDifferentTimeSlotContent,
    {
      labels,
      loading,
      onClickPrevious,
      onSelectTimeSlot,
      selected,
      timeSlots
    }
  ));
};
export {
  AppointmentPickDifferentTimeSlot as default
};
//# sourceMappingURL=AppointmentPickDifferentTimeSlot.js.map
